import { format } from 'date-fns'

import { httpClient } from '@/services/http/httpClient'

export type ForumCommentFile = {
  url: string
  name: string
  type: string
  size?: number
} | null

export type IdeaForumHttpResponse = {
  likes: number
  views: number
  comments: {
    id: string
    userId: string
    ideaId: string
    content: string
    parent_forum_comment_id: string | null
    tennantId: string
    createdAt: string
    user: {
      id: string
      name: string
      email: string
      image?: string
    }
    file?: ForumCommentFile
  }[]
  isLiked: boolean
}

export type IdeaForumComment = {
  id: string
  user: {
    id: string
    name: string
    image?: string
  }
  createdAt: string
  content: string
  parentCommentId?: string
  comments: IdeaForumComment[]
  file: ForumCommentFile
}

export type IdeaForum = {
  likes: number
  views: number
  comments: IdeaForumComment[]
  isLiked: boolean
}

export async function getIdeaForum(id: string): Promise<IdeaForum> {
  const { data } = await httpClient.get<IdeaForumHttpResponse>(
    `/ideas/forum/${id}`,
  )

  const commentsMap = new Map<string, IdeaForumComment>()

  const comments = data.comments.map((comment) => {
    const formattedComment: IdeaForumComment = {
      id: comment.id,
      user: {
        id: comment.user.id,
        name: comment.user.name,
        image: comment.user.image,
      },
      createdAt: format(
        new Date(comment.createdAt.replace('Z', '')),
        'dd/MM/yyyy',
      ),
      content: comment.content,
      parentCommentId: comment.parent_forum_comment_id || undefined,
      file: comment.file ?? null,
      comments: [],
    }

    commentsMap.set(formattedComment.id, formattedComment)
    return formattedComment
  })

  const rootComments: IdeaForumComment[] = []

  comments.forEach((comment) => {
    if (comment.parentCommentId) {
      const parent = commentsMap.get(comment.parentCommentId)
      if (parent) {
        parent.comments.push(comment)
      }
    } else {
      rootComments.push(comment)
    }
  })

  return {
    likes: data.likes ?? 0,
    views: data.views ?? 0,
    isLiked: data.isLiked,
    comments: rootComments,
  }
}
